import { CONTACT_ICON } from "../../../constants/icons";
import { CONTACT } from "../../../constants/urls";

export const Sidebar = {
  addButton: { title: "ایجاد طرف حساب" },
  menu: [{ title: "لیست طرف حساب‌ها", icon: CONTACT_ICON, link: CONTACT }]
};
